export const isSimpleClick = (event: MouseEvent) => {
  return event.button === 0 && !event.ctrlKey;
};

export const preventDefault = (event: Event) => {
  event.preventDefault();
};

export const preventDefaultForCurrentTarget = (event: MouseEvent) => {
  if (event.currentTarget === event.target) {
    event.preventDefault();
  }
};
